var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params !== undefined)?_c('img',{staticStyle:{"height":"100px"},attrs:{"src":this.params.value,"alt":"img"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }